module.exports = __webpack_public_path__ + "img/ic_publicity_detail1_4.a36129ba.png";